export const USER_ACL_OBJECTS = [
    'UsersList',
    'UserDetail',
    'UserNew',
    // UserProfile is accessible for all as it load logged in user
    // temporary accounts, roles - for both we don't have routes it is inside USER routes
];
